var Module = (function () {
    function Module() {
    }
    Module.fromJson = function (data) {
        var m = new Module();
        Object.keys(data).forEach(function (key) {
            m[key] = data[key];
        });
        m.title = m.title || { de: '', internal: '', en: '' };
        m.description = m.description || { de: '', internal: '', en: '' };
        return m;
    };
    return Module;
}());
export { Module };



// WEBPACK FOOTER //
// /codebuild/output/src3658806670/src/client/web-client/src/app/shared/models/Module.ts.pre-build-optimizer.js